<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-18 13:39:25
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">派单列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="地区">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.wxVerifiedStatus"
                    placeholder="请选择地区"
                  >
                    <el-option label="已认证" value="1"></el-option>
                    <el-option label="未认证" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.cadeVerifyStatus"
                    placeholder="请选择微信状态"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option label="待发布" value="1"></el-option>
                    <el-option label="发布中" value="2"></el-option>
                    <el-option label="待实做" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="认证状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择认证状态"
                    style="margin-right: auto"
                  >
                    <el-option label="身份认证" value="1"></el-option>
                    <el-option label="未认证" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div class="titleBox">
          <div
            v-for="(item, index) in regulationData"
            :key="index"
            v-if="item.type == 1"
          >
            显示结束时间：<span style="color: #000">{{
              item.dispatchRule.dispatchEndTimeValue | maxTime
            }}</span>
          </div>
          <div class="indexBtn" style="margin-left: 24px" @click="goViolation">
            <img src="../../assets/imgs/setting.png" alt="" />
            <div>设置规则</div>
          </div>
        </div>
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="creatorName" label="客户" align="center">
          </el-table-column>
          <el-table-column prop="title" label="任务名称" align="center">
          </el-table-column>
          <el-table-column prop="area" label="区域" align="center">
          </el-table-column>
          <el-table-column label="要求人数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.readiesNum }}/{{ scope.row.membersNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="距离结束时间" align="center">
            <template slot-scope="scope">
              <span :class="[scope.row.selectTime < 0 ? 'redColor' : '']"
                ><span v-if="scope.row.selectTime < 0">-</span
                ><span v-if="scope.row.day > 0">{{ scope.row.day }}天</span
                ><span v-if="scope.row.hour1 > 0"
                  >{{ scope.row.hour1 }}小时</span
                ><span v-if="scope.row.middle > 0"
                  >{{ scope.row.middle }}分</span
                ><span>{{ scope.row.theTime }}秒</span></span
              >
            </template>
          </el-table-column>
          <el-table-column label="总金额" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.price | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="加价" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.markUp | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail(scope.row)">查看</div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  派单
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="派单设置"
        :visible.sync="dialogFormVisible1"
        width="800px"
      >
        <el-form ref="ruleForm" :model="ruleForm2">
          <el-row :gutter="4">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="ruleForm2.name"
                  placeholder="请输入名称"
                  @focus="clearData"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="ruleForm2.phone"
                  placeholder="请输入手机号"
                  @focus="clearData"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="身份状态">
                <el-select v-model="ruleForm2.status" placeholder="请选择">
                  <el-option
                    v-for="item in tableData2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="getUserList(allocationJobNo)"
                  class="btn"
                  >查询</el-button
                >
                <el-button @click="resetForm1()">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-bottom: 20px">搜索总数：{{ tableData1.length }}</div>
        <el-table
          ref="singleTable"
          :data="tableData1"
          style="width: 100%"
          highlight-current-row
          @current-change="selectItem"
          max-height="250"
        >
          <el-table-column align="center" width="50">
            <template slot-scope="scope">
              <div
                :class="[scope.row.id == selectUserId ? 'select' : 'noselect']"
              ></div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">{{
              scope.row.accountType == 0
                ? scope.row.companyName
                : scope.row.cardName
            }}</template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">{{
              scope.row.accountType == 0
                ? "企业"
                : scope.row.accountType == 0
                ? "企业员工"
                : "临勤"
            }}</template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" @click="allocation()" class="btn"
            >派单</el-button
          >
          <el-button @click="resetForm2()">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        wxVerifiedStatus: "",
        cadeVerifyStatus: "",
        status: "",
      },
      tableData: [],
      tableData1: [],
      tableData2: [
        { label: "企业", value: "0" },
        { label: "临勤", value: "2" },
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      time: "",
      ruleForm2: {
        name: "",
        phone: "",
        status: "",
      },
      dialogFormVisible1: false,
      allocationId: "",
      allocationJobNo: "",
      selectUserId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      regulationData: [],
    };
  },
  mounted() {
    this.getList();
    this.time = Date.parse(new Date());
    this.regulation();
  },
  methods: {
    resetForm2() {
      this.selectUserId = "";
      this.allocationId = "";
      this.allocationJobNo = "";
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.dialogFormVisible1 = false;
    },
    allocation() {
      if (!this.selectUserId) {
        this.$message({
          message: "请选择保安",
          type: "warning",
        });
        return;
      }
      let param = {
        jobId: this.allocationId,
        bodygurardId: this.selectUserId,
      };
      this.$axios
        .post(`/admapi/dispatchjob/add`, param)
        .then(({ data }) => {
          this.$message({
            message: "派单成功",
            type: "success",
          });
          this.dialogFormVisible1 = false;
          this.getList();
          this.selectUserId = "";
          this.allocationId = "";
        })
        .catch()
        .finally();
    },
    clearData() {
      this.selectUserId = "";
      this.$refs.singleTable.clearSelection();
    },
    handleChange(val) {
      this.ruleForm2.status = val[val.length - 1];
    },
    selectItem(val) {
      this.selectUserId = val == null ? "" : val.id;
    },
    resetForm1() {
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.getUserList();
    },
    getUserList(val) {
      let param = {
        page: 1,
        pageSize: 1000,
        accountType: this.ruleForm2.status,
        cardName: this.ruleForm2.name,
        phone: this.ruleForm2.phone,
        jobNo: val,
      };
      // if (this.ruleForm2.name != "") {
      //   param.queryParams.push({
      //     name: "nickname",
      //     type: "input",
      //     value: this.ruleForm2.name
      //   });
      // }
      // if (this.ruleForm2.phone != "") {
      //   param.queryParams.push({
      //     name: "phone",
      //     type: "input",
      //     value: this.ruleForm2.phone
      //   });
      // }
      // if (this.ruleForm2.status != "") {
      //   param.queryParams.push({
      //     name: "account_type",
      //     type: "select",
      //     values: [
      //       {
      //         itemKey: this.ruleForm2.status
      //       }
      //     ]
      //   });
      // }
      this.$axios
        .post(`/admapi/bodyguard/dispathMemberlist`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
        })
        .catch()
        .finally();
    },
    goDetail(val) {
      this.$router.push({
        path: "/taskDetail",
        query: {
          id: val.id,
        },
      });
    },
    handleEdit(val) {
      this.allocationId = val.id;
      this.getUserList(val.jobNo);
      this.dialogFormVisible1 = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.wxVerifiedStatus = "";
      this.ruleForm.cadeVerifyStatus = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/dispatchjob/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            arr[i].selectTime = Date.parse(arr[i].jobEnd) - this.time;
            if (Date.parse(arr[i].jobEnd) - this.time < 0) {
              arr[i].time = (Date.parse(arr[i].jobEnd) - this.time) * -1;
            } else {
              arr[i].time = Date.parse(arr[i].jobEnd) - this.time;
            }
            var theTime = parseInt(arr[i].time / 1000); // 秒
            var middle = 0; // 分
            var hour = 0; // 小时
            var day = 0; // 天
            if (theTime >= 60) {
              middle = parseInt(theTime / 60);
              theTime = parseInt(theTime % 60);
              if (middle >= 60) {
                hour = parseInt(middle / 60);
                middle = parseInt(middle % 60);
                if (hour >= 24) {
                  day = parseInt(hour / 24);
                  hour = parseInt(hour % 24);
                }
              }
            }
            var result = "" + parseInt(theTime) + "秒";
            arr[i].theTime = parseInt(theTime);
            arr[i].hour1 = 0;
            arr[i].middle = 0;
            arr[i].day = 0;
            if (middle > 0) {
              result = "" + parseInt(middle) + "分" + result;
              arr[i].middle = parseInt(middle);
            }
            if (hour > 0) {
              result = "" + parseInt(hour) + "小时" + result;
              arr[i].hour1 = parseInt(hour);
            }
            if (day > 0) {
              result = "" + parseInt(day) + "天" + result;
              arr[i].day = parseInt(day);
            }
          }
          this.tableData = arr;
          this.total = data.page.totalPages;
        })
        .catch()
        .finally();
    },
    regulation() {
      let param = {
        page: 1,
        pageSize: 10,
      };
      this.$axios
        .post(`/admapi/setrule/list`, param)
        .then(({ data }) => {
          this.regulationData = data;
        })
        .catch()
        .finally();
    },
    //设置规则
    goViolation() {
      this.$router.push("/regulation");
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.redColor {
  color: red;
}
.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}
.titleBox {
  margin-bottom: 20px;
  color: #86909c;
  display: flex;
  align-items: center;
  justify-content: end;
}
.indexBtn {
  padding: 0px 10px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #165dff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2c68ff;
  line-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: none;
}
.indexBtn img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.noselect {
  width: 10px;
  height: 10px;
  border: #165dff 1px solid;
  border-radius: 10px;
}
</style>
<style>
.el-form-item__label {
  min-width: 0 !important;
}
</style>
